module.exports = __webpack_public_path__ + "img/logo1.4704189a.png";